/**
 * Zapkart brand tokens (sage / teal / charcoal) for Ant Design v6.
 */
export const antdV4CompatTheme = {
  hashed: false,
  cssVar: true,
  token: {
    colorPrimary: '#6E9F87',
    colorLink: '#6E9F87',
    colorInfo: '#4F8F9D',
    colorSuccess: '#6E9F87',
    colorWarning: '#F4B183',
    colorError: '#ff4d4f',
    borderRadius: 12,
    borderRadiusLG: 16,
    borderRadiusSM: 8,
    fontSize: 14,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    controlHeight: 36,
    wireframe: false,
    colorBorder: '#E4E8E6',
    colorText: '#242A27',
    colorTextSecondary: '#6B726E',
    colorTextHeading: '#242A27',
    colorBgContainer: '#fff',
    colorBgLayout: '#F4FBFA',
    lineWidth: 1
  },
  components: {
    Button: {
      borderRadius: 999,
      controlHeight: 36,
      primaryShadow: 'none'
    },
    Input: {
      borderRadius: 12,
      controlHeight: 36
    },
    Select: {
      borderRadius: 12,
      controlHeight: 36
    },
    Modal: {
      borderRadiusLG: 16
    },
    Collapse: {
      borderRadiusLG: 16,
      headerPadding: '12px 16px',
      contentPadding: '16px'
    },
    Tag: {
      borderRadiusSM: 8
    },
    Card: {
      borderRadiusLG: 16
    },
    Table: {
      borderRadius: 12
    },
    Notification: {
      borderRadiusLG: 16
    },
    Steps: {
      colorPrimary: '#6E9F87'
    }
  }
};
